import { makeStyles } from "@material-ui/core/styles";

export const useDialogStyles = makeStyles((theme) => ({
    dialogContent: {
        padding: 0,
        margin: 0
    },
    header: {
        background:
            "linear-gradient(to right top, #322241, #4d3960, #6a5181, #886ba4, #a886c8)",
        color: "white",
        padding: theme.spacing(3),
        borderRadius: "4px 4px 0 0",
        position: "sticky",
        top: 0,
        zIndex: 1
    },
    headerTitle: {
        fontSize: "1.5rem",
        fontWeight: "bold",
        marginBottom: theme.spacing(1)
    },
    headerSubtitle: {
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: "0.9rem"
    },
    progressSection: {
        padding: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: "#fafafa"
    },
    progressBar: {
        width: "100%",
        height: 8,
        backgroundColor: theme.palette.grey[300],
        borderRadius: 4,
        overflow: "hidden"
    },
    progressFill: {
        height: "100%",
        backgroundColor: theme.palette.primary.main,
        transition: "width 0.3s ease"
    },
    stagesContainer: {
        padding: theme.spacing(3)
    },
    stageHeader: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2)
    },
    stageNumber: {
        width: 32,
        height: 32,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontWeight: "bold",
        marginRight: theme.spacing(2)
    },
    stageTitle: {
        fontSize: "1.1rem",
        fontWeight: 600,
        color: theme.palette.text.primary
    },
    stageType: {
        fontSize: "1.0rem",
        fontWeight: 400,
        color: theme.palette.text.primary,
        marginLeft: theme.spacing(1),
        fontStyle: "italic"
    },
    stageStatus: {
        padding: "4px 12px",
        borderRadius: 12,
        fontSize: "0.75rem",
        fontWeight: 500,
        color: "white",
        marginTop: theme.spacing(0.5),
        marginRight: theme.spacing(1)
    },
    stageProgress: {
        fontSize: "0.85rem",
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5)
    },
    timelineContainer: {
        marginLeft: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        borderLeft: `2px solid ${theme.palette.grey[300]}`
    },
    approverCard: {
        backgroundColor: "#f8f9fa",
        borderRadius: 8,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(1),
        position: "relative"
    },
    timelineDot: {
        position: "absolute",
        left: -35,
        top: 16,
        width: 16,
        height: 16,
        borderRadius: "50%",
        border: "2px solid white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        fontWeight: "bold",
        color: "white"
    },
    timelineConnector: {
        position: "absolute",
        left: -27,
        top: 32,
        width: 2,
        height: "calc(100% - 16px)",
        backgroundColor: theme.palette.grey[300]
    },
    approverName: {
        fontWeight: 500,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(0.5)
    },
    approverEmail: {
        fontSize: "0.85rem",
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1)
    },
    actionStatus: {
        padding: "4px 8px",
        borderRadius: 4,
        fontSize: "0.75rem",
        fontWeight: 500,
        color: "white",
        marginRight: theme.spacing(1)
    },
    actionDate: {
        fontSize: "0.85rem",
        color: theme.palette.text.secondary
    },
    notesContainer: {
        backgroundColor: "white",
        padding: theme.spacing(1.5),
        borderRadius: 4,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        marginTop: theme.spacing(1)
    },
    notesText: {
        fontSize: "0.85rem",
        color: theme.palette.text.primary,
        fontStyle: "italic"
    },
    stageDivider: {
        margin: theme.spacing(3, 0),
        backgroundColor: theme.palette.divider
    },
    footer: {
        backgroundColor: "#fafafa",
        padding: theme.spacing(2, 3),
        borderRadius: "0 0 4px 4px",
        display: "flex",
        justifyContent: "flex-end"
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    chipCard: {
        marginLeft: 16,
        borderRadius: 6
    }
}));
